var StoreWaitBoardItemModel = require('./store-wait-board-item');

var StoreWaitBoardModel = Backbone.Epoxy.Model.extend({
  initialize: function() { },

  defaults: {
    isInitialized: false,
    isFeatureEnabled: false,
    isStoreConnected: false,
    hasItems: false,
    waitBoardItems: new Backbone.Collection(null, { model: StoreWaitBoardItemModel }),
    storeId: null,
    overrideMessage: null,
    store: {},
  },

  computeds: {
    isReady: {
      deps: ['isInitialized', 'isFeatureEnabled', 'isStoreConnected', 'hasItems'],
      get: function() {
        return this.get('isInitialized') &&
          this.get('isFeatureEnabled') &&
          this.get('isStoreConnected') &&
          this.get('hasItems');
      }
    },

    statusMessage: {
      deps: ['isInitialized', 'isFeatureEnabled', 'isStoreConnected', 'hasItems', 'overrideMessage'],
      get: function() {        
        if (!this.get('isInitialized')) {
          return "Loading..."
        }
        if (this.get('overrideMessage') != null) {
          return this.get('overrideMessage');
        }
        if (!this.get('isFeatureEnabled')) {
          return "The wait board is not available."; //Case 1 - store not updated
        }
        if (!this.get('isStoreConnected')) {
          return "The wait board is currently unavailable. Please try again or call the store to check on wait times."; //Case 2 - no connection or error
        }
        if (!this.get('hasItems')) {
          return "There is no wait right now."
        }
        //TODO:: do we need store closed and other cases? Probably...
        return "";
      }
    }

    /*
    storeHasPhone: function() {
      return this.get('store') && this.get('store').phone != null;
    },
    storeGetPhone: function() {
      return this.get('storeHasPhone') ? this.get('store').phone : null;
    },

    storeHasName: function() {
      return this.get('store') && this.get('store').name != null;
    },
    storeGetName: function() {
      return this.get('storeHasName') ? this.get('store').name : null;
    },

    storeHasAddress1: function() {
      return this.get('store') && this.get('store').address1 != null;
    },
    storeGetAddress1: function() {
      return this.get('storeHasAddress1') ? this.get('store').address1 : null;
    },

    storeHasAddress2: function() {
      return this.get('store') && this.get('store').address2 != null;
    },
    storeGetAddress2: function() {
      return this.get('storeHasAddress2') ? this.get('store').address2 : null;
    },

    storeGetGmapsHref: function() {
      var params = $.param({ daddr: this.get('store').address1 + ' ' + this.get('store').address2 });
      return "https://maps.google.com?" + params;
    },
    */
  },

  validation: { },

  bindModel: function(data) {
    this.set('isInitialized', true);


    var waitBoardInfo = ((data || {}).value || {}).publicWaitBoard;
    /// General checks
    this.get('waitBoardItems').reset();
    this.set('isFeatureEnabled', typeof(waitBoardInfo) !== undefined);
    this.set('isStoreConnected', ((data || {}).success == true));
    this.set('overrideMessage', ((data || {}).reason));

    this.set('hasItems', false);
    
    if (!this.get('isFeatureEnabled') || !this.get('isStoreConnected')) {
      return;
    }

    /// Wait Board Items
    var index = 0;
    _.each(waitBoardInfo, _.bind(function(waitBoardItem) {
      var waitBoardItemModel = new StoreWaitBoardItemModel();
      waitBoardItemModel.bindModel(waitBoardItem, index);

      this.get('waitBoardItems').push(waitBoardItemModel);

      index ++;
    }, this));

    this.set('hasItems', this.get('waitBoardItems').length);


    /*
    /// Store Info
    this.set('store', {
      // storeId: waitBoardInfo.store.id,
      name: waitBoardInfo.store.name,
      address1: waitBoardInfo.store.address1,
      address2: waitBoardInfo.store.address2,
      phone: waitBoardInfo.store.phone,
      // email: waitBoardInfo.store.email,
      // website: waitBoardInfo.store.website,
      // numRatings: waitBoardInfo.store.numRatings,
      // avgRating: waitBoardInfo.store.avgRating % 1 == 0.5 ? waitBoardInfo.store.avgRating : Math.round(waitBoardInfo.store.avgRating),
      // facebookUrl: waitBoardInfo.store.facebookUrl,
      // googlePlusUrl: waitBoardInfo.store.googlePlusUrl,
      // twitterUrl: waitBoardInfo.store.twitterUrl,
      // yelpUrl: waitBoardInfo.store.yelpUrl,
      // photoId: waitBoardInfo.store.photoId,
      // timezone: waitBoardInfo.store.timeZone,
      // storeLocalTime: waitBoardInfo.store.storeLocalTime
    });
    */
  }
});

module.exports = StoreWaitBoardModel;